import { Divider } from '@/components/ui';
import { assets, C, externalLinks } from '@/theme/tokens';

interface FooterLink {
  label: string;
  href: string;
}

{/*  { label: 'Backer Tiers', href: '#tiers' },
  { label: 'How It Works', href: '#how-it-works' },*/}

const campaignLinks: ReadonlyArray<FooterLink> = [
  { label: 'Reserve Your Spot', href: '#reserve' },
];

const gameLinks: ReadonlyArray<FooterLink> = [
  { label: 'Playtest Free Now!', href: externalLinks.demo },
  { label: 'What is QuestXR', href: '#what-is-questxr' },
  { label: 'Features', href: '#features' },
];

function FooterColumn({ title, links }: { title: string; links: ReadonlyArray<FooterLink> }) {
  return (
    <div>
      <p
        style={{
          fontFamily: "'Cinzel',serif",
          fontSize: 11,
          color: C.bronze,
          letterSpacing: '3px',
          textTransform: 'uppercase',
          marginBottom: 14,
        }}
      >
        {title}
      </p>
      {links.map(({ label, href }) => {
        const isExternal = href.startsWith('http');
        return (
          <p key={label}>
            <a
              href={href}
              target={isExternal ? '_blank' : undefined}
              rel={isExternal ? 'noopener noreferrer' : undefined}
              style={{
                fontSize: 13,
                color: C.dim,
                textDecoration: 'none',
                lineHeight: 2.2,
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = C.bronze;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = C.dim;
              }}
            >
              {label}
            </a>
          </p>
        );
      })}
    </div>
  );
}

/** Bottom footer with logo, link columns, divider, and copyright line. */
export function Footer() {
  return (
    <footer
      style={{
        background: C.bgFooter,
        padding: '48px 24px 32px',
        borderTop: `1px solid rgba(193,154,107,0.25)`,
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 32,
            marginBottom: 40,
          }}
        >
          <div>
            <img src={assets.logo} alt="QuestXR" style={{ height: 28, marginBottom: 12 }} />
            <p style={{ fontSize: 13, color: C.dim, maxWidth: 260, lineHeight: 1.6 }}>
              A tabletop RPG in real life. AR combat, AI NPCs, real-world quests.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 64, flexWrap: 'wrap' }}>
            <FooterColumn title="Campaign" links={campaignLinks} />
            <FooterColumn title="The Game" links={gameLinks} />
          </div>
        </div>
        <Divider bg={C.bgFooter} />
        <p
          style={{
            textAlign: 'center',
            marginTop: 24,
            fontSize: 11,
            color: C.dim,
            letterSpacing: '1px',
          }}
        >
          © 2026 QuestXR · All rights reserved ✧
        </p>
      </div>
    </footer>
  );
}
